
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/precario",
      function () {
        return require("private-next-pages/precario/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/precario"])
      });
    }
  